import React, { FunctionComponent } from 'react';
import ArticleSmallCard, { ArticleSmallCardProps } from '../article-small-card/ArticleSmallCard';
import Skeleton from './ArticleNextPrevFooter.skeleton';
import * as styles from './ArticleNextPrevFooter.style';

export interface ArticleNextPrevFooterProps {
  loading?: boolean,
  error?: Error,
  prev?: ArticleSmallCardProps,
  next?: ArticleSmallCardProps,
}

const ArticleNextPrevFooter: FunctionComponent<ArticleNextPrevFooterProps> = ({
  loading = false,
  error,
  prev,
  next,
}) => {
  if (loading) {
    return (
      <div data-ref="next-prev-footer-loading">
        <Skeleton />
      </div>
    );
  }

  if (error) {
    // Don't notify an error to user (it's not necessary)
    return null;
  }

  return (
    <div
      data-ref="next-prev-footer-content"
      css={styles.base}
    >
      <div css={styles.content}>
        <div css={styles.block}>
          {prev && (
            <>
              <div css={styles.title}>
                Precedente
              </div>
              <div css={styles.article}>
                <ArticleSmallCard {...prev} />
              </div>
            </>
          )}
        </div>
        <div css={styles.block}>
          {next && (
            <>
              <div css={styles.title}>
                Successivo
              </div>
              <div css={styles.article}>
                <ArticleSmallCard {...next} />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleNextPrevFooter;
